<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.id)" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-20">
        <div class="font-bold">Credit Card</div>
        <hr class="short-line left">
        <form @submit.prevent="editCreditCard('editCreditCard')" data-vv-scope="editCreditCard">
          <div class="row">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Branch</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="c_branch" v-model="selectedBranch" @change="onChangeBranch" :options="dataBranch"
                    class="form-control border-bottom"></b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">CS</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select v-validate="'required'" name="formType" v-model="dataCreditCard.handle_by"
                    :options="dataCS" class="form-control border-bottom" />
                  <span class="error">{{ errors.first('formType') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Holder Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.credit_card_holder_name"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-validate="'numeric'"
                    v-model="dataCreditCard.credit_card_number" name="credit_card_number" type="text"></b-form-input>
                  <span class="error">{{ errors.first('credit_card_number') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Bank Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.credit_card_bank_name"
                    name="credit_card_bank_name" type="text"></b-form-input>
                  <span class="error">{{ errors.first('credit_card_bank_name') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Type</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_type" class="form-control border-bottom"
                    v-model="dataCreditCard.credit_card_type">
                    <option value="VISA">VISA</option>
                    <option value="Mastercard">Mastercard</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Month Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_month_expired" class="form-control border-bottom"
                    v-model="dataCreditCard.credit_card_month_expired">
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </b-form-select>
                  <!-- <flat-pickr :config="config" v-model="dataCreditCard.credit_card_month_expired" name="credit_card_month_expired" class="w-100 border-bottom"></flat-pickr> -->
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Year Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.credit_card_year_expired"
                    name="credit_card_year_expired" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Saved Token</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input disabled class="form-control border-bottom bg-transparent"
                    v-model="dataCreditCard.membership_saved_token" name="membership_saved_token"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Updated</div>
                </b-col>
                <b-col sm="9" class="d-flex align-items-center">
                  <input type="checkbox" id="agreeForm" name="checkbox_agree" v-model="is_edit_cc" />
                </b-col>
              </b-row>
            </div>
            <!-- <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card CVV</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom" v-model="dataCreditCard.card_cvv" name="card_cvv" type="text"></b-form-input>
                  <span class="error">{{ errors.first('editCreditCard.card_cvv') }}</span>

                </b-col>
              </b-row>
            </div> -->
            <div class="col-12">
              <hr>
              <div class="mb-10">Notes</div>
              <textarea name="notes" v-validate="'required'" v-model="dataCreditCard.notes" class="w-100"
                rows="4"></textarea>
              <span class="error">{{ errors.first('editCreditCard.notes') }}</span>
            </div>
          </div>
          <div class="text-right mt-15">
            <button v-if="!isViewOnly" type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'addSales',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      loadingActive: false,
      is_edit_cc: true,
      dataCS: [],
      dataBranch: [],
      selectedBranch: '',
      dataCreditCard: {
        handle_by: null,
        credit_card_type: 'VISA',
        credit_card_bank_name: '',
        credit_card_holder_name: '',
        credit_card_number: '',
        credit_card_month_expired: '',
        credit_card_year_expired: '',
        membership_saved_token: '',
        card_cvv: 123,
        notes: ''
      },
      isViewOnly: false
    }
  },
  methods: {
    editCreditCard(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to submit this data and waiting for approval',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Save now!',
        cancelButtonText: 'No, Cancel it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((confirm) => {
        if (confirm.value) {
          this.$validator.validateAll(event).then(async result => {
            if (result) {
              try {
                const regisCard = await axios.get('transaction/v1/payment/card/register?' + 'card_number=' + this.dataCreditCard.credit_card_number + '&card_exp_month=' + this.dataCreditCard.credit_card_month_expired + '&card_exp_year=' + this.dataCreditCard.credit_card_year_expired + '&client_key=' + this.membership_saved_token + '&member_id=' + this.$route.query.id, { headers: { "Authorization": `Basic 'VlQtc2VydmVyLWZ0NUp0ZElQYVUzM2ljbmNMMXlxNVl5bjo6'` } })
                if (regisCard.data.status_code == '200') {
                  this.dataCreditCard.membership_saved_token = regisCard.data.saved_token_id

                  const payload = {
                    member_id: this.$route.query.id,
                    request_data: this.dataCreditCard,
                    action: 'EDIT',
                    notes: 'Update CreditCard',
                    description: `Request to update credit card with number ${this.dataCreditCard.credit_card_number} and name ${this.dataCreditCard.credit_card_holder_name} | notes: ${this.dataCreditCard.notes} `,
                  }
                  this.loadingActive = true

                  axios.post('/crm/v1/approval_request/module_member', payload).then(response => {
                    this.loadingActive = false
                    this.$swal('Successfully!', 'Data has been submitted and waiting for approval!', 'success')
                    this.fetchData()
                  }).catch((error) => {
                    this.loadingActive = false
                    console.log('Error', error)
                    this.$swal('Failed!', 'Failed or Data has been waiting for approval!', 'error')
                  })

                  // remark when approval future is ready
                  // try{
                  //   const is_edit_cc = this.is_edit_cc ? 1 : 0
                  //   const updateCard = await axios.put('fitness/v1/member/' + this.$route.query.id + '?is_edit_cc=' + is_edit_cc, this.dataCreditCard)
                  //   this.$router.push('/memberEntry/edit?id=' + this.$route.query.id)
                  //   this.$toast.success('data saved successfully!', 'Success', {
                  //     position: 'topCenter',
                  //     icon: 'icon-envelope',
                  //     progressBarColor: 'rgb(0, 255, 184)',
                  //     theme: 'dark',
                  //     backgroundColor: '#565c70',
                  //     messageColor: '#fff'
                  //   })
                  // } catch(error){
                  //   // console.log('error', error)
                  //   this.$toast.success('cant saved data!', 'Error', {
                  //     position: 'topCenter',
                  //     icon: 'icon-envelope',
                  //     progressBarColor: 'rgb(0, 255, 184)',
                  //     theme: 'dark',
                  //     backgroundColor: '#565c70',
                  //     messageColor: '#fff'
                  //   })
                  // }
                } else {
                  this.$toast.success('Error Register Card: ' + regisCard.data.status_message, 'Error', {
                    position: 'topCenter',
                    icon: 'icon-envelope',
                    progressBarColor: 'rgb(0, 255, 184)',
                    theme: 'dark',
                    backgroundColor: '#565c70',
                    messageColor: '#fff',
                  })
                }
                console.log('Regsiter Card', regisCard.data)
              } catch (error) {
                // console.log('error', error)
                this.$toast.success('Error Register Card', 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
              }
            } else {
              this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    async onChangeBranch() {
      this.dataCreditCard.handle_by = null
      let cs = await axios.get('crm/v1/customer_service?branch_id=' + this.selectedBranch)
      this.dataCS = [{ value: null, text: 'Please select' }]
      cs.data.data.rows.forEach(row => {
        this.dataCS.push({ value: row.id, text: row.id + ' ' + row.name })
      })
    },
    async fetchData() {
      axios.get('fitness/v1/member/' + this.$route.query.id).then(response => {
        this.dataCreditCard.credit_card_holder_name = response.data.data.credit_card_holder_name
        this.dataCreditCard.credit_card_number = response.data.data.credit_card_number
        this.dataCreditCard.credit_card_month_expired = response.data.data.credit_card_month_expired
        this.dataCreditCard.credit_card_year_expired = response.data.data.credit_card_year_expired
        this.dataCreditCard.membership_saved_token = response.data.data.membership_saved_token
        this.dataCreditCard.credit_card_type = response.data.data.credit_card_type
        this.dataCreditCard.credit_card_bank_name = response.data.data.credit_card_bank_name
        this.dataCreditCard.handle_by = response.data.data.customer_service_id
        this.selectedBranch = response.data.data.customer_service_branch_id
        // console.log('liat', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })

      let cs = await axios.get('crm/v1/customer_service?branch_id=' + this.selectedBranch)
      this.dataCS = [{ value: null, text: 'Please select' }]
      cs.data.data.rows.forEach(row => {
        this.dataCS.push({ value: row.id, text: row.id + ' ' + row.name })
      })

      axios
        .get("fitness/v1/branch/")
        .then(response => {
          const data = response.data.data.rows;
          this.dataBranch = [{ value: '', text: 'Please select' }];
          data.forEach(element => {
            this.dataBranch.push({ value: element.id, text: element.name })
          });
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData()

    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
  }
}
</script>

<style></style>
